import React from "react";
import Card from "../../Home/shared/Card";
import { type Orders } from "../../../common/interfaces";

const SalesFloorCard: React.FC<
  Orders & { className?: string; updateCallback?: () => void }
> = (props) => {
  // El backend ya filtra las órdenes y productos correctamente con display_type=floor
  // No necesitamos filtrar aquí, mostramos todos los productos que vienen del API
  return <Card {...props} filterType="salesfloor" />;
};



export default SalesFloorCard;
